// to avoid name conflicts:
const LOCAL_STORAGE_TEST_KEY = '7352dd32-2b61-4767-809c-8e59bfeaa8e1'

// fix for safari incognitomode: https://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an/14555361#14555361
const canUseLocalStorage = () => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_TEST_KEY, 'test')
    const test = window.localStorage.getItem(LOCAL_STORAGE_TEST_KEY)
    return test === 'test'
  } catch (error) {
    return false
  }
}

export const localStorageSetItem = (item, value) => {
  if (canUseLocalStorage()) {
    window.localStorage.setItem(item, value)
  }
}

export const localStorageGetItem = (item) => {
  if (canUseLocalStorage()) {
    return window.localStorage.getItem(item)
  }
  return null
}
